import {
  Button,
  Dimmer,
  DimmerDimmable,
  Form,
  Loader,
  Modal,
  TextArea,
} from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

export interface ModalAnnulationRecuProps {
  loading: boolean;
  onValidate: (motif: string) => void;
  onClose: () => void;
}

const ModalAnnulationRecu = (props: ModalAnnulationRecuProps) => {
  const { loading, onClose, onValidate } = props;

  const [motif, setMotif] = React.useState('');

  const handleChange = React.useCallback((e, { value }) => {
    setMotif(value);
  }, []);

  return (
    <Modal open closeIcon {...(!loading && { onClose })} size="tiny">
      <Modal.Header>Annulation du reçu</Modal.Header>
      <Modal.Content>
        <DimmerDimmable as={Form} dimmed={loading}>
          <Dimmer active={loading} inverted>
            <Loader inverted content="Chargement" />
          </Dimmer>
          <Form.Field required>
            <label>Motif d&apos;annulation</label>
            <TextArea
              {...(!loading && { onChange: handleChange })}
              maxLength={120}
              value={motif}
              data-testid="textarea-motif-annulation-recu"
            />
          </Form.Field>
        </DimmerDimmable>
      </Modal.Content>
      <Modal.Actions>
        <Button
          data-testid="button-close-annulation-recu"
          onClick={() => onClose()}
          basic
          size="tiny"
          icon="close"
          content="Annuler"
          loading={loading}
          disabled={loading}
        />
        <Button
          data-testid="button-validate-annulation-recu"
          positive
          onClick={() => onValidate(motif)}
          disabled={_.isEmpty(motif) || loading}
          content="Valider"
          icon="checkmark"
          loading={loading}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ModalAnnulationRecu;
